import script from "./addGroupDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./addGroupDialog.vue?vue&type=script&lang=ts&setup=true"

import "./addGroupDialog.vue?vue&type=style&index=0&id=28d1dfe6&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d1dfe6"]])

export default __exports__